import Vue from 'vue'
import Vuex from 'vuex'
import app from '@/store/modules/app'
import auth from '@/store/modules/auth'
import controlPanel from '@/store/modules/controlPanel'
import user from '@/store/modules/user'

Vue.use(Vuex)

// const debug = process.env.NODE_ENV !== 'production'
const debug = false

export default new Vuex.Store({
  modules: {
    app,
    auth,
    controlPanel,
    user
  },
  strict: debug
})



// WEBPACK FOOTER //
// ./src/store/index.js